module.exports = require('../../lib/constants/main');
